import { ChangePasswordErrorTypes, FirebaseAuthErrorCode } from '@griply/types';

import { WRONG_PASSWORD_CODES } from './map-reauth-error';

export const mapChangePasswordError = (
  code: string,
): ChangePasswordErrorTypes => {
  if (WRONG_PASSWORD_CODES.includes(code)) {
    return ChangePasswordErrorTypes.WrongPassword;
  }

  if (code === FirebaseAuthErrorCode.WeakPassword) {
    return ChangePasswordErrorTypes.WeakPassword;
  }

  return ChangePasswordErrorTypes.Unknown;
};
